import { Timeline } from 'antd'
import React, { useEffect, useRef } from 'react'

const ActivityTimeLine = (props) => {
  
  return (
    <Timeline items={props.items}/>
  )
}

export default ActivityTimeLine